export default __webpack_public_path__ + "static/media/about.6cb73b29.svg";